"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InstallationPanel = void 0;
var InstallationCard_cms_1 = require("../components/panels/ScheduleInstallPanel/InstallationCard/InstallationCard.cms");
var AppointmentScheduler_cms_1 = require("../components/panels/ScheduleInstallPanel/InstallationCard/AppointmentScheduler/AppointmentScheduler.cms");
var LiveCalendar_cms_1 = require("../components/panels/ScheduleInstallPanel/InstallationCard/LiveCalendar/LiveCalendar.cms");
var PreferenceCalendar_cms_1 = require("../components/panels/ScheduleInstallPanel/InstallationCard/PreferenceCalendar/PreferenceCalendar.cms");
var LiveSchedule_cms_1 = require("../components/panels/ScheduleInstallPanel/InstallationCard/LiveSchedule/LiveSchedule.cms");
var PreferenceSchedule_cms_1 = require("../components/panels/ScheduleInstallPanel/InstallationCard/PreferenceSchedule/PreferenceSchedule.cms");
var Scheduler_cms_1 = require("../components/panels/ScheduleInstallPanel/InstallationCard/Scheduler/Scheduler.cms");
var InstallationContact_cms_1 = require("../components/panels/ScheduleInstallPanel/InstallationContact/InstallationContact.cms");
var InstallationContactDetails_cms_1 = require("../components/panels/ScheduleInstallPanel/InstallationContactDetails/InstallationContactDetails.cms");
var PhoneInfo_cms_1 = require("../components/panels/ScheduleInstallPanel/PhoneInfo/PhoneInfo.cms");
var ScheduleInstallPanel_cms_1 = require("../components/panels/ScheduleInstallPanel/ScheduleInstallPanel.cms");
var ServiceAddress_cms_1 = require("../components/panels/ScheduleInstallPanel/ServiceAddress/ServiceAddress.cms");
var ScheduleHeader_cms_1 = require("../components/panels/ScheduleInstallPanel/ScheduleHeader/ScheduleHeader.cms");
var DescriptionCard_cms_1 = require("../components/panels/ScheduleInstallPanel/DescriptionCard/DescriptionCard.cms");
var SaveScheduleButton_cms_1 = require("../components/panels/ScheduleInstallPanel/SaveScheduleButton/SaveScheduleButton.cms");
var TechTracker_cms_1 = require("../components/panels/ScheduleInstallPanel/TechTracker/TechTracker.cms");
var InstallationPanel = /** @class */ (function () {
    function InstallationPanel() {
        this.installationDetails = new InstallationCard_cms_1.InstallationCardCms();
        this.appointmentScheduler = new AppointmentScheduler_cms_1.AppointmentSchedulerCms();
        this.liveCalendar = new LiveCalendar_cms_1.LiveCalendarCms();
        this.liveSchedule = new LiveSchedule_cms_1.LiveScheduleCms();
        this.preferenceSchedule = new PreferenceSchedule_cms_1.PreferenceScheduleCms();
        this.preferenceCalendar = new PreferenceCalendar_cms_1.PreferenceCalendarCms();
        this.scheduler = new Scheduler_cms_1.SchedulerCms();
        this.installationContact = new InstallationContact_cms_1.InstallationContactCms();
        this.installationContactDetails = new InstallationContactDetails_cms_1.InstallationContactDetailsCms();
        this.PhoneInfo = new PhoneInfo_cms_1.PhoneInfoCms();
        this.panelContent = new ScheduleInstallPanel_cms_1.ScheduleInstallPanelCms();
        this.ServiceAddress = new ServiceAddress_cms_1.ServiceAddressCms();
        this.scheduleHeader = new ScheduleHeader_cms_1.ScheduleHeaderCms();
        this.descriptionCard = new DescriptionCard_cms_1.DescriptionCardCms();
        this.saveSchedule = new SaveScheduleButton_cms_1.SaveScheduleButtonCms();
        this.techTracker = new TechTracker_cms_1.TechTrackerCms();
    }
    return InstallationPanel;
}());
exports.InstallationPanel = InstallationPanel;
//# sourceMappingURL=InstallationPanel.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/cms/InstallationPanel.cms.js
// module id = 2020
// module chunks = 8